import {
  BRIEFREPORTLIST,
} from 'actions/briefreport';
import {reducerPackage} from "../../utils";

export const briefreportList = reducerPackage(BRIEFREPORTLIST);
